//@ts-ignore
import Twemoji from 'react-twemoji';

export default function EmojiSelection(
    {
        filteredEmojis,
        focusedEmoji,
        tagEmoji
    }: any
) {
    return (
        <>
            {filteredEmojis?.length !== 0 && (
                <div className="absolute bottom-14 rounded-lg cursor-pointer p-1 w-full bg-brand-dark">
                    <div className="flex items-start space-x-2 rounded-t-lg w-full">
                        <div className="flex flex-col items-start p-2 gap-2 rounded-t-lg w-full max-h-96 overflow-auto" style={{ scrollbarWidth: "thin", scrollbarColor: "rgb(40, 160, 42) rgb(27 27 29)" }}>
                            {filteredEmojis?.slice(0, 16)
                                .sort((a: any, b: any) => {
                                    if (a.name && !b.name) return -1;
                                    if (!a.name && b.name) return 1;
                                    return 0;
                                }).map((emoji: any, index: number) => (

                                    <div key={index} className={`font-semibold text-gray-300 w-full p-2 rounded-lg hover:bg-brand-darkest ${focusedEmoji === index ? "bg-brand-darkest" : ""
                                        } ${index === filteredEmojis.length - 1 ? "rounded-b-lg" : ""
                                        }`} onClick={() => tagEmoji(filteredEmojis[index])}>
                                        <div className="flex items-center rounded-t-lg">
                                            <div className="flex items-center space-x-2 rounded-t-lg">
                                                {emoji.url && (
                                                    <img src={emoji.url} className="h-6 w-6 rounded-full" />
                                                )}
                                                {!emoji.url && (
                                                    <span className="h-6 w-6 rounded-full flex items-center justify-center">
                                                        <Twemoji options={{ className: 'h-6 w-6' }}>{emoji.emoji}</Twemoji>
                                                    </span>
                                                )}
                                                <span className="font-semibold text-gray-300">{emoji.name || emoji.description.replace(/_/g, ' ').replace(/\b\w/g, (l: any) => l.toUpperCase())}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}